import React, { useState, useEffect } from 'react';
import { useAuth } from "../../context/DBContext";
import { useNavigate } from "react-router-dom";
import firebaseErrorMessages from '../../firebaseError';
import { Alert } from 'antd';
import loginImage from './Picture5.jpg';

export default function LoginPage() {
  const { login, sendEmailVerification } = useAuth();
  const [error, setError] = useState();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission
    const email = event.target.email.value;
    const password = event.target.password.value;

    try {
      setError("");
      setLoading(true);
      const userCredential = await login(email, password);

      if (userCredential.user && !userCredential.user.emailVerified) {
        await sendEmailVerification();
        navigate("/emailverification");
      } else if (userCredential.user) {
        navigate("/");
      } else {
        // console.log('User not authenticated');
      }
    } catch (error) {
      const firebaseErrorCode = error.code;
      const customErrorMessage = firebaseErrorMessages[firebaseErrorCode] || error.message;
      setError(customErrorMessage);
      // console.log(error);
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <div className="flex min-h-full flex-1">
        {/* Left: Form section (50%) */}
        <div className="flex flex-1 flex-col justify-center px-4 py-12 sm:px-6 lg:px-20 xl:px-24 lg:w-1/2">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div>
            <a href="/">
    <img src="/assets/enablelogo.png" alt="Logo" className="w-[120px]" />
  </a>
              <h2 className="mt-8 text-2xl font-bold tracking-tight text-gray-900">Sign in to your account</h2>
              <p className="mt-2 text-sm text-gray-500">
                Not a member?{' '}
                <a href="/signup" className="font-semibold text-blue-600 hover:text-blue-500">
                  Sign Up Now
                </a>
              </p>
            </div>

            <div className="mt-10">
              {error && (
                <Alert message={error} type="error" showIcon className="mb-4" />
              )}
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-900">
                    Email address
                  </label>
                  <div className="mt-2">
                    <input
                      id="email"
                      name="email"
                      type="email"
                      required
                      autoComplete="email"
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="password" className="block text-sm font-medium text-gray-900">
                    Password
                  </label>
                  <div className="mt-2">
                    <input
                      id="password"
                      name="password"
                      type="password"
                      required
                      autoComplete="current-password"
                      className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 sm:text-sm"
                    />
                  </div>
                </div>

                <div className="flex items-center justify-between">
                  <div className="text-sm">
                    <a href="/forgotpassword" className="font-semibold text-blue-600 hover:text-blue-500">
                      Forgot password?
                    </a>
                  </div>
                </div>

                <div>
                  <button
                    type="submit"
                    disabled={loading}
                    className="flex w-full justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
                  >
                    {loading ? 'Signing in...' : 'Sign in'}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        {/* Right: Image section (50%) */}
        <div className="relative hidden w-1/2 lg:block">
          <img
            alt="Background"
            src={loginImage}
            className="absolute inset-0 h-full w-full object-cover"
          />
        </div>
      </div>
    </>
  );
}
